document.addEventListener("DOMContentLoaded", () => {
    const searchButtonElements = document.querySelectorAll(
        ".header-icons-search-button, .header-icons-search-reset",
    );

    const handleSearchButtonElementClick = () => {
        document
            .querySelector(".header-icons-search-form")
            .classList.toggle("header-icons-search-form-active");

        document.querySelector(".header-icons-search-form input").focus();
    };

    if (searchButtonElements) {
        searchButtonElements.forEach((searchButtonElement) => {
            searchButtonElement.addEventListener(
                "click",
                handleSearchButtonElementClick,
            );
        });
    }
});
